import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const queries = buildGraphqlQuery(
  'Board',
  `_id
  tags
  remarks
  name
  icon
  items {
    _id
 entity {
      _id
      code
      name
      price
      summary
      coverImage
      status
      inventory {
        _id
        quantityOnHand
      }
    }
  }

`
)
export const buildQuery = (field: string) => buildGraphqlQuery('Board', `_id ${field}`)
